import React from 'react'
import Loadable from 'react-loadable'

const UpgradeIcon = Loadable({
	loader: () => import('../misc/UpgradeIcons'),
	loading() {
		return null
	}
})

class UpgradeProFeaturesSymbolRowSymbol extends React.Component{

	render(){	

		return(
			<div className='upgrade--proFeaturesSymbolRow-symbol'>
				<div className='upgrade--proFeaturesSymbolRow-symbol-iconContainer'>
					<UpgradeIcon name={`proFeatureSymbol-${this.props.iconName}`} />
				</div>
				<div className='upgrade--proFeaturesSymbolRow-symbol-label'>
					{this.props.label}
				</div>				
			</div>
			
		)	
	}
				
}

class UpgradeProFeaturesSymbolRow extends React.Component{

	render(){	

		return(
			<div className='upgrade--proFeaturesSymbolRow'>
				
				<UpgradeProFeaturesSymbolRowSymbol 
					label='No Set Limits'
					iconName='limit'
				/>
				<UpgradeProFeaturesSymbolRowSymbol 
					label='Shared Packs'
					iconName='sharedPack'
				/>
				<UpgradeProFeaturesSymbolRowSymbol 
					label='Instant Images'					
					iconName='images'
				/>				
				<UpgradeProFeaturesSymbolRowSymbol 
					label='Unlimited Scoresheet'
					iconName='scoresheet'
				/>

				<div className='upgrade--proFeaturesSymbolRow-bgContainer'>
					<UpgradeIcon name='proFeatureSymbolRowCloud'/>
				</div>	

			</div>
			
		)	
	}
				
}

export default UpgradeProFeaturesSymbolRow





// WEBPACK FOOTER //
// ./src/components/upgrade/UpgradeProFeaturesSymbolRow.js